import { render } from "./CallToActionComponent.vue?vue&type=template&id=4b5d5d38&scoped=true"
import script from "./CallToActionComponent.vue?vue&type=script&lang=js"
export * from "./CallToActionComponent.vue?vue&type=script&lang=js"

import "./CallToActionComponent.vue?vue&type=style&index=0&id=4b5d5d38&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b5d5d38"]])

export default __exports__